/* istanbul ignore file */

import { environment } from './environments/environment';

type DataLayer = unknown[];
type GtagFn = (...args: DataLayer) => void;

declare global {
  interface Window {
    gtag: GtagFn;
    dataLayer: DataLayer;
  }
}

const gtag: GtagFn = function gtag(...args) {
  window.dataLayer.push(args);
};

window.dataLayer = window.dataLayer || [];
window.gtag = gtag;

export function initGTM() {
  const gtm = environment.GTM;
  if (!gtm) {
    return;
  }

  const script = document.createElement('script');
  script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtm}');`;

  document.head.prepend(script);
}
